import { Badge, Box, Flex, Icon, Tab, TabList, TabPanel, TabPanels, Table, Tabs, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { format } from 'date-fns';
import { FiClock, FiShoppingBag } from 'react-icons/fi';

export const HistoryTabs = ({ pointsHistory, redeemHistory }) => {
    const formatDate = (dateString) => {
        try {
            return format(new Date(dateString), 'dd MMM yyyy, HH:mm');
        } catch {
            return dateString;
        }
    };

    const getStatusColor = (status) => {
        const statusColors = {
            completed: 'green',
            pending: 'yellow',
            failed: 'red',
            cancelled: 'gray',
            used: 'green',
            active: 'green',
            expired: 'gray',
            redeem: 'green',
            earn: 'orange',
        };
        return statusColors[status?.toLowerCase()] || 'gray';
    };

    console.log(pointsHistory);

    return (
        <Box mt={8} bg='white' borderRadius='2xl' p={{ base: 4, md: 6 }} border='1px' borderColor='gray.100' boxShadow='sm'>
            <Tabs colorScheme='red' variant='soft-rounded'>
                <TabList mb={4} gap={2} flexWrap='wrap'>
                    <Tab borderRadius='full' _selected={{ bg: 'red.100', color: 'red.700' }}>
                        <Flex align='center' gap={2}>
                            <Icon as={FiClock} />
                            Points History
                        </Flex>
                    </Tab>
                    <Tab borderRadius='full' _selected={{ bg: 'pink.100', color: 'pink.700' }}>
                        <Flex align='center' gap={2}>
                            <Icon as={FiShoppingBag} />
                            Redeem History
                        </Flex>
                    </Tab>
                </TabList>

                <TabPanels>
                    {/* Points History Panel */}
                    <TabPanel p={0}>
                        {pointsHistory.length === 0 ? (
                            <Text color='gray.500' textAlign='center' py={8}>
                                No points history yet
                            </Text>
                        ) : (
                            <Box overflowX='auto'>
                                <Table variant='simple' size='sm'>
                                    <Thead bg='gray.50'>
                                        <Tr>
                                            <Th py={4}>Date</Th>
                                            <Th py={4}>Description</Th>
                                            <Th py={4} isNumeric>
                                                Points
                                            </Th>
                                            <Th py={4}>Status</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {pointsHistory.map((transaction) => (
                                            <Tr key={transaction.id} _hover={{ bg: 'gray.50' }}>
                                                <Td fontSize='sm' color='gray.600'>
                                                    {formatDate(transaction.date)}
                                                </Td>
                                                <Td fontWeight='medium'>{transaction.description}</Td>
                                                <Td isNumeric fontWeight='bold' color={transaction.amount >= 0 ? 'green.500' : 'red.500'}>
                                                    {transaction.amount >= 0 ? '+' : ''}
                                                    {transaction.amount.toLocaleString('id-ID')}
                                                </Td>
                                                <Td>
                                                    <Badge colorScheme={getStatusColor(transaction.status)} borderRadius='full' px={2}>
                                                        {transaction.status}
                                                    </Badge>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </Box>
                        )}
                    </TabPanel>

                    {/* Redeem History Panel */}
                    <TabPanel p={0}>
                        {redeemHistory.length === 0 ? (
                            <Text color='gray.500' textAlign='center' py={8}>
                                No redeem history yet
                            </Text>
                        ) : (
                            <Box overflowX='auto'>
                                <Table variant='simple' size='sm'>
                                    <Thead bg='gray.50'>
                                        <Tr>
                                            <Th py={4}>Date</Th>
                                            <Th py={4}>Voucher</Th>
                                            <Th py={4}>Code</Th>
                                            <Th py={4} isNumeric>
                                                Cost
                                            </Th>
                                            <Th py={4}>Status</Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {redeemHistory.map((history) => (
                                            <Tr key={history.id} _hover={{ bg: 'gray.50' }}>
                                                <Td fontSize='sm' color='gray.600'>
                                                    {formatDate(history.date)}
                                                </Td>
                                                <Td fontWeight='medium'>{history.voucherName}</Td>
                                                <Td>
                                                    <Text fontFamily='monospace' bg='gray.100' px={2} py={1} borderRadius='md' display='inline-block' fontSize='xs'>
                                                        {history.code}
                                                    </Text>
                                                </Td>
                                                <Td isNumeric fontWeight='bold' color='red.500'>
                                                    -{history.pointsCost.toLocaleString('id-ID')}
                                                </Td>
                                                <Td>
                                                    <Badge colorScheme={getStatusColor(history.status)} borderRadius='full' px={2}>
                                                        {history.status}
                                                    </Badge>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </Box>
                        )}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
};
